


















import {Component, Vue} from 'vue-property-decorator'
import {Getter, Mutation} from 'vuex-class'
import {Task} from '@/store/types'
import {Modal} from '@/components/common'
import SignaturePad from 'signature_pad'

@Component({
  components: {
    Modal,
  },
})
export default class SummaryInfoSignature extends Vue {
  @Getter('task') public task!: Task
  @Mutation('setSignatureModal') public setSignatureModal!: any
  @Mutation('removeTaskSignature') public removeTaskSignature!: any
  @Mutation('setSignature') public setSignature!: any
  public canvas!: any
  public signaturePad!: any
  public signatureMissing: boolean = false

  public sign() {
    if (this.signaturePad.isEmpty()) {
      return this.signatureMissing = true
    }
    this.removeTaskSignature(this.task.id)
    this.setSignature({task_id: this.task.id, image: this.signaturePad.toDataURL()})
    this.setSignatureModal(false)
    this.$router.push(`/survey/${this.task.id}`)
  }

  public resizeCanvas() {
    const ratio = Math.max(window.devicePixelRatio || 1, 1)
    this.canvas.width = this.canvas.clientWidth * ratio
    this.canvas.height = this.canvas.clientHeight * ratio
    this.canvas.getContext('2d').scale(ratio, ratio)
    this.signaturePad.clear()
  }
  public clearPad() {
    this.signaturePad.clear()
  }

  public mounted() {
    this.canvas = this.$el.querySelector('canvas')
    this.signaturePad = new SignaturePad(this.canvas, {
      onBegin: () => { this.signatureMissing = false },
    })

    this.resizeCanvas()
  }
}
